import { t } from "@bookingcom/lingojs-core";
import { differenceInCalendarDays, parse } from "date-fns";
import { formatFareName } from "@flights/branded-fares";
export const getModalTitle = (i18n, segments, tripType, showTripTypeTitle) => {
    if (!tripType || !segments)
        return "";
    const destination = segments[0].arrivalAirport.cityName;
    const origin = segments[0].departureAirport.cityName;
    if (showTripTypeTitle) {
        if (tripType === "ROUNDTRIP" && destination) {
            return i18n.trans(t("flights_fd_rt_title", { variables: { destination } }));
        }
        if (tripType === "ONEWAY" && destination) {
            return i18n.trans(t("flights_fd_oneway_title", { variables: { destination } }));
        }
        if (tripType === "MULTISTOP" && origin) {
            return i18n.trans(t("flights_fd_multi_title", { variables: { origin } }));
        }
    }
    if (!destination) {
        return i18n.trans(t("flights_meta_land_next_flight_details_header_no_city"));
    }
    if (tripType === "ONEWAY" || tripType === "ROUNDTRIP") {
        return i18n.trans(t("flights_meta_land_next_flight_details_header_city", { variables: { city_name: destination } }));
    }
    return i18n.trans(t("flights_details_name"));
};
export const getIncludedBaggageHeader = (i18n, brandedFareInfo, flexibleTicket) => {
    if (brandedFareInfo) {
        return `${i18n.trans(t("flights_fd_branded_header", {
            variables: {
                bf_name: `${formatFareName(brandedFareInfo.fareName)}`
            }
        }))} `.replace(":", "");
    }
    if (flexibleTicket) {
        return i18n.trans(t("flights_fd_standard_header"));
    }
    return i18n.trans(t("flights_included_baggage_title"));
};
export const getIncludedBaggageSubHeader = (i18n, brandedFareInfo, flexibleTicket) => {
    if (brandedFareInfo) {
        return i18n.trans(t("flights_fd_branded_subheader"));
    }
    else if (flexibleTicket) {
        return i18n.trans(t("flights_fd_standard_subheader"));
    }
    return i18n.trans(t("flights_included_baggage_sub"));
};
export const getBookWindowDays = (segments) => {
    if (!segments || segments.length === 0) {
        return null;
    }
    const departureDate = parse(segments[0].departureTime, "yyyy-MM-dd'T'HH:mm:ss", new Date());
    return differenceInCalendarDays(departureDate, new Date());
};
